import { combineReducers } from 'redux';
import ListingsReducer from '../containers/Listings/reducer';
import usersReducer from '../containers/Users/reducers';
const rootReducer = combineReducers({
  listings: ListingsReducer,
  users: usersReducer,
});

export default rootReducer;
